module.exports = __webpack_public_path__ + "img/high_income.0196b48f.svg";